/*
 * @Description: file content
 * @Author: Provenr
 * @Date: 2019-07-17 10:25:30
 * @LastEditors: Provenr
 * @LastEditTime: 2019-08-12 15:34:52
 */
//  ios方法

// 商品详情
function IosGoodsDetail(productId) {
  window.webkit.messageHandlers.goodsDetail.postMessage({'ph_goods_id': productId});
}

// 专题
function IosSpecialMethod (Id, title) {
  window.webkit.messageHandlers.SpecialMethod.postMessage({'specialId': Id, 'specialTitle': title})
}

// 门店
function IosStoreMethod () {
  window.webkit.messageHandlers.StoreMethod.postMessage({})
}
// 回收
function IosJumpToDoMethod (type) {
  window.webkit.messageHandlers.jumpTodo.postMessage({'ph_dynamic_type': type})
}
// 限时抢
function IosTimelimitMethod () {
  window.webkit.messageHandlers.TimelimitMethod.postMessage({})
}

function Ioslogin (type) {
  window.webkit.messageHandlers.isLoginCallback.postMessage({'ph_method_type': type})
}

// 获取登录用户信息
function IosGetUserInfo () {
  return window.webkit.messageHandlers.getAppUser.postMessage({})
}
// 获取app 支付
function IosAppPay (type, goods, flag) {
  return window.webkit.messageHandlers.appPay.postMessage({'ph_pay_type': type, 'ph_pay_order_info': goods, 'ph_pay_order_type': flag})
}
// 上传图片
//  参数（len：图片上传限定数,H5 前端数组下标）返回上传图片服务端地址，类型字符串数组
function IosUploadImage (len, index) {
  return window.webkit.messageHandlers.upImage.postMessage({'ph_max_upload_img_count': len, 'ph_current_img_index': index})
}
// 保存证书图片
function IosSaveCertificate (url) {
  window.webkit.messageHandlers.saveCertificate.postMessage({'ph_certificate_url': url})
}
// 复制到剪粘板
function IosClipboardCopy (txt) {
  window.webkit.messageHandlers.clipboardCopy.postMessage({'ph_paste_text': txt})
}
// 退出登录
function IosLoginOut () {
  window.webkit.messageHandlers.loginOut.postMessage({})
}
// 唤起环信客服
function IosGoEasemob (hx_id, hx_name, hx_photo, flag, order) {
  window.webkit.messageHandlers.goEasemob.postMessage({'ph_hx_user_id': hx_id, 'ph_hx_user_name': hx_name, 'ph_hx_user_profile': hx_photo, 'ph_hx_user_type': flag, 'ph_hx_user_message': order})
}
// 调用登录
function IosTransferLogin () {
  window.webkit.messageHandlers.transferLogin.postMessage({})
}
// 调用鉴定订单列表
function IosTransferApprList (type) {
  window.webkit.messageHandlers.transferApprList.postMessage({'ph_method_type': type})
}
// 实物鉴定
function IosGoodsIdentify () {
  window.webkit.messageHandlers.goodsIdentify.postMessage({})
}
// 下载APP
function IosOpenApp () {
  window.webkit.messageHandlers.openApp.postMessage({})
}
// 跳转首页
function IosHome () {
  window.webkit.messageHandlers.goHome.postMessage({})
}
// 跳转首页
function IosBack () {
  window.webkit.messageHandlers.goBack.postMessage({})
}
// 分享
function IosShare (type, url, logo, title, content) {
  window.webkit.messageHandlers.shareAction.postMessage({'ph_share_type': type, 'ph_share_link_url': url, 'ph_share_img': logo, 'ph_share_title': title, 'ph_share_desc': content})
}
// 分享小程序
function IosPrmShare (pageUrl, userName, path, desc, hdImage, thumbImage, withShareTicked, miniProgramType) {
  window.webkit.messageHandlers.prmShare.postMessage({'pageUrl': pageUrl, 'userName': userName, 'path': path, 'desc': desc, 'hdImage': hdImage, 'thumbImage': thumbImage, 'withShareTicked': withShareTicked, 'miniProgramType': miniProgramType})
}
function IosCameraCode() {
  window.webkit.messageHandlers.CameraCode.postMessage({})
}
function IosJumptoH5(title, url, isShare) {
  window.webkit.messageHandlers.JumptoH5.postMessage({'ph_H5_title': title, 'ph_H5_link_url': url, 'ph_H5_is_hide_share': isShare});
}

const IOS = {
  IosGoodsDetail,
  IosSpecialMethod,
  IosStoreMethod,
  IosTimelimitMethod,
  Ioslogin,
  IosJumpToDoMethod,
  IosGetUserInfo,
  IosAppPay,
  IosUploadImage,
  IosClipboardCopy,
  IosLoginOut,
  IosSaveCertificate,
  IosGoEasemob,
  IosTransferLogin,
  IosTransferApprList,
  IosGoodsIdentify,
  IosOpenApp,
  IosHome,
  IosBack,
  IosShare,
  IosPrmShare,
  IosCameraCode,
  IosJumptoH5
}
export {
  IOS
}

// Android方法
// 商品详情
function AndroidGoodsDetail (productId) {
  window.anzhuo.goodsDetail(productId)
}

// 专题
function AndroidSpecialMethod (id, title) {
  window.anzhuo.SpecialMethod(id, title)
}

// 门店
function AndroidStoreMethod () {
  window.anzhuo.StoreMethod()
}

// 回收
function AndroidJumpToDoMethod (type) {
  window.anzhuo.jumpTodo(type)
}

// 限时抢
function AndroidTimelimitMethod () {
  window.anzhuo.TimelimitMethod()
}

function AndroidLogin (type) {
  window.anzhuo.isLoginCallback(type)
}

function AndroidCoupon (userid) {
  window.anzhuo.Coupon(userid)
}

// 获取登录用户信息
function AndroidGetUserInfo () {
  return window.anzhuo.getAppUser()
}
// app支付
// 调起支付，参数（type：支付方式（1：支付宝 2：微信）  goods：商品信息【json 字符串】）
function AndroidAppPay (type, goods, flag) {
  return window.anzhuo.appPay(type, goods, flag)
}

// 上传图片
// 参数（len：图片上传限定数,H5 前端数组下标）返回上传图片服务端地址，类型字符串数组
function AndroidUploadImage (len, index) {
  return window.anzhuo.upImage(len, index)
}
// 保存证书图片
function AndroidSaveCertificate (url) {
  window.anzhuo.saveCertificate(url)
}
// 复制（剪切板）
function AndroidClipboardCopy (txt) {
  window.anzhuo.clipboardCopy(txt)
}
// 退出登录
function AndroidLoginOut () {
  window.anzhuo.loginOut()
}
// 唤起环信客服
function AndroidGoEasemob (hx_id, hx_name, hx_photo, flag, order) {
  window.anzhuo.goEasemob(hx_id, hx_name, hx_photo, flag, order)
}
// 调用登录
function AndroidTransferLogin () {
  window.anzhuo.transferLogin()
}
// 调用鉴定订单列表
function AndroidTransferApprList (type) {
  window.anzhuo.transferApprList(type)
}
// 获取title
function AndroidGetTitle (txt) {
  window.anzhuo.getTitle(txt)
}
// 实物鉴定

function AndroidGoodsIdentify () {
  window.anzhuo.goodsIdentify()
}
// 下载APP
function AndroidOpenApp () {
  window.anzhuo.openApp()
}
// 跳转首页
function AndroidHome () {
  window.anzhuo.goHome()
}

// 返回
function AndroidBack () {
  window.anzhuo.goBack()
}
// 分享
function AndroidShare (type, url, logo, title, content) {
  window.anzhuo.shareAction(type, url, logo, title, content)
}
// 返回环信
function AndroidBackEasemob () {
  window.anzhuo.backEasemob()
}
// 分享小程序
function AndroidPrmShare (pageUrl, userName, path, desc, hdImage, thumbImage, withShareTicked, miniProgramType) {
  window.anzhuo.prmShare(pageUrl, userName, path, desc, hdImage, thumbImage, withShareTicked, miniProgramType)
}
function AndroidCameraCode() {
  window.anzhuo.CameraCode() 
}
function AndroidJumptoH5(title, url, isShare) {
  window.anzhuo.JumptoH5(title, url, isShare);
}

const Android = {
  AndroidGoodsDetail,
  AndroidSpecialMethod,
  AndroidStoreMethod,
  AndroidTimelimitMethod,
  AndroidLogin,
  AndroidCoupon,
  AndroidJumpToDoMethod,
  AndroidGetUserInfo,
  AndroidAppPay,
  AndroidUploadImage,
  AndroidClipboardCopy,
  AndroidLoginOut,
  AndroidSaveCertificate,
  AndroidGoEasemob,
  AndroidTransferLogin,
  AndroidTransferApprList,
  AndroidGetTitle,
  AndroidGoodsIdentify,
  AndroidOpenApp,
  AndroidHome,
  AndroidBack,
  AndroidShare,
  AndroidBackEasemob,
  AndroidPrmShare,
  AndroidCameraCode,
  AndroidJumptoH5
}
export {
  Android
}
